namespace GeniuzPOS.Purchase {
    export enum CancelFgstatus {
        Use = 0,
        cancle = 1,
        posttocancle = 2
    }
    Serenity.Decorators.registerEnumType(CancelFgstatus, 'GeniuzPOS.Purchase.CancelFgstatus');
}
